import { State } from '../typings/state';

export const getAppState = (state: State) => state.app;
export const getMobile = (state: State) => state.app.mobile;
export const getAuth = (state: State) => state.app.auth;
export const getCountry = (state: State) => state.app.auth.country;
export const getUserProfile = (state: State) => state.app.auth.profile;
export const getDirection = (state: State) => state.app.direction;
export const getLanguage = (state: State) => state.app.language;
export const getLanguages = (state: State) => state.app.languages;
export const getLoader = (state: State) => state.app.loader;
export const getAlerts = (state: State) => state.app.alerts;
export const isAuthenticated = (state: State) => state.app.authenticated;
export const isInitialized = (state: State) => state.app.initialized;
export const getLegalEntity = (state: State) => state.app.legalEntity;
export const getVersion = (state: State) => state.app.version;
export const getParameters = (state: State) => state.app.parameters;
export const getCopyright = (state: State) => state.app.copyright;
